import { Component, Input } from '@angular/core';

@Component({
  selector: 'local-seo-source-name-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  standalone: false,
})
export class IconComponent {
  @Input() iconUrl: string;
  @Input() name: string;
  @Input() iconSize = 36;
  @Input() ecosystemSources: number;
  @Input() shadow = false;
  @Input() defaulticonUrl: string;

  getHeightStyle(): { [klass: string]: any } {
    return {
      height: `${this.iconSize}px`,
      lineHeight: `${this.iconSize}px`,
    };
  }

  getIconSize(): { [klass: string]: any } {
    return {
      width: `${this.iconSize}px`,
      height: `${this.iconSize}px`,
    };
  }
  getDefaultProfileImage() {
    this.iconUrl = this.defaulticonUrl;
  }
}
